import moment from 'moment';
import { NumberUtil } from './number';
import i18n from '../i18/i18'

export const DateUtil = {
    moment,
    diff: (start_date, end_date) => {
        const start = moment(start_date)
        const end = moment(end_date)

        let diff = end.diff(start, 'days')

        if(diff > 0) return `${diff} día${diff > 1 ? 's': ''}`;

        diff = end.diff(start, 'hours')
        if(diff > 0) return `${diff} hora${diff > 1 ? 's': ''}`;

        diff = end.diff(start, 'minutes')
        if(diff > 0) return `${diff} minuto${diff > 1 ? 's': ''}`;

        diff = end.diff(start, 'seconds')
        return `${diff} segundos`;
    },

    format: (date) => {
        return moment(date).format('DD-MM-YYYY HH:mm')
    },

    ISOFormat: (date) => {
        return moment(date).format('YYYY-MM-DD')
    },
    timeFormat:(date) => {
        return moment(date).format('HH:mm')
    },
    formatTime: (duration) => {
        // let duration = time.slice(0,8)
        let chunks = duration.split(':')
        
        let hours = +chunks[0] || 0
        let minutes = +chunks[1] || 0
        let seconds = +chunks[2] || 0

        if(hours > 0) {
            return `${NumberUtil.format(hours+parseFloat((minutes/60).toFixed(1)))+i18n.t("date-time.hours")}`
        }
        
        if(minutes > 0) {
            return `${NumberUtil.format(minutes+parseFloat((seconds/60).toFixed(1)))+i18n.t("date-time.minutes")} `
        }

        return `${NumberUtil.format(seconds)+i18n.t("date-time.seconds")}`
    }
    
}